App.uiWordCount = {
  initialize: function() {
    $('.uiWordCount').textareaCounter();
  }
};

// uiModal
  // Modals can be opened manually by calling App.uiModal.open( $el ) or
  // they can be opened with an anchor (.uiModalLink) with a data-modal=".myModalSelector"
App.uiModal = {
  opts: {
    containerId: null,
    closeHtml: '<a class="modalCloseImg" title="Close"></a>',
    closeClass: 'uiModalClose img-circle',
    dataId: null,
    focus: false,
    overlayClose: true
  },
  initialize: function() {
    var opts;

    $(document).on('click', '.uiModalClose', function(e) {
      $.modal.close();
    });

    this.$el = $('.uiModal');

    if ( !this.$el.length ) return;

    $.extend(this.opts, {
      minHeight: this.$el.data('minheight')
    });

    this.$el.each( _.bind(this._autoOpen, this) );

    this.bindLinks();
  },
  _autoOpen: function(i, el) {
    var $t = $(el);

    if ( $t.data('autoopen') || $t.hasClass('autoopen') )
    {
      this.open( $t );
    }
  },
  bindLinks: function() {
    $('.uiModalLink').each( _.bind(this._handleLinks, this) );

    return this;
  },
  close: function() {
    $.modal.close();
    return this;
  },
  // This is necessary to keep iframes with embeds from floating above modals
  fixFrames: function() {
    $('iframe:visible').addClass('uiModalHiddenFrame').hide();
    return this;
  },
  _handleLinks: function(i, el) {
    var self = this,
        $el = $(el),
        modal = $el.data('modal'),
        $modal;

    if ( !modal ) return;

    $el.on('click.uiModal', function(e) {
      e.preventDefault();

      // find the modal from selector each time; should not be cached
      $modal = $( normalizeSelector(modal) );

      if ( !$modal.length ) return;

      self.open( $modal );
    });
  },
  onClose: function(s) {
    this.restoreFrames();

    $.modal.close();
    $('.uiModal').remove(); // for some reason this gets left behind, so remove manually
  },
  open: function($modal) {
    var opts, classNames;

    classNames = $modal.attr('class') || "";
    classNames = $.trim( classNames.replace('uiModal', '') );
    classNames = classNames.split(" ");
    classNames = _.uniq( _.compact( classNames ) );
    classNames = classNames.join(" ");

    opts = $.extend({}, this.opts, {
      containerId: $modal.attr('id')
    });

    $modal.data('origId', opts.containerId).removeAttr('id');

    opts.onClose = _.bind(this.onClose, this);

    $modal.modal( opts );

    return this.fixFrames();
  },
  restoreFrames: function() {
    $('iframe.uiModalHiddenFrame').removeClass('uiModalHiddenFrame').show();
    return this;
  }
};
// end uiModal


// Lesson page preview, remove links
App.lessonPreview = {
	initialize: function(){
		if ( $('.onLessonsPreviewView').length == 0 ) return;
		$('#footerInternal').find('.leftLinks a').removeAttr('href').addClass('inactive').css('color','#9F9F9F').css('cursor','text');
	}
};
// end Lesson page preview
